import { render, staticRenderFns } from "./StudentEvaluationHistoryEdit.vue?vue&type=template&id=d95f1842"
import script from "./StudentEvaluationHistoryEdit.vue?vue&type=script&lang=js"
export * from "./StudentEvaluationHistoryEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports